/* unplugin-vue-components disabled */import script from "./information-form.vue?vue&type=script&setup=true&lang=js"
export * from "./information-form.vue?vue&type=script&setup=true&lang=js"

import "./information-form.vue?vue&type=style&index=0&id=11ffed9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_do6gl7biqum247ry4qofa4hfiq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11ffed9d"]])

export default __exports__